var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"juridical-page"},[(!_vm.isLoading)?[_c('h1',{staticClass:"juridical-page__title"},[_vm._v(" "+_vm._s(_vm.contentItem.name)+" ")]),_c('div',{staticClass:"juridical-page__card s-card row"},[_c('div',{staticClass:"juridical-page__text"},[_c('AppMarkDown',{attrs:{"text":_vm.contentItem.content}})],1)])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }